import { SECOND_BAGGAGE } from '../../products';
import { getGraphQlSelection } from './utils/getGraphQlSelection';
const {
  name: formSection
} = SECOND_BAGGAGE;
const secondBaggagePerTraveler = {
  getGraphQlSelection,
  formSection,
  ...SECOND_BAGGAGE
};
export default secondBaggagePerTraveler;
//# sourceMappingURL=index.js.map